import { Injectable } from "@angular/core";
import {
  Http,
  Response,
  Headers,
  Request,
  RequestOptions,
} from "@angular/http";
import { throwError as observableThrowError, Observable } from "rxjs";
import { environment } from "../../environments/environment";
import { map, catchError } from "rxjs/operators";
import { AuthHeaderService } from "../views/authheader.service";

@Injectable({
  providedIn: 'root'
})
export class CarrierinvoiceService {

  getcarrierinvoiceurl: string;
  constructor(private http: Http, private _headerService: AuthHeaderService) {

    this.getcarrierinvoiceurl = environment.getcarrierinvoiceurl;
  }

  createCarrierInvoice(load) {
    // console.log(JSON.stringify(load));
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.post(this.getcarrierinvoiceurl, load, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  getLoadsForCarrierPay() {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });

    return this.http.get(this.getcarrierinvoiceurl, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  getCarrierInvoiceInfo(invoiceId) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(this.getcarrierinvoiceurl + "/invoice/" + invoiceId, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  cancelInvoice(load) {
    // console.log(JSON.stringify(load));
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.post(this.getcarrierinvoiceurl + "/cancel", load, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  createCarrierPayment(load) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http
      .post(this.getcarrierinvoiceurl + "/carrierpayment", load, options)
      .pipe(
        map((response) => response.json()),
        catchError((error: Response) => {
          return observableThrowError(error);
        })
      );
  }
  getCarrierPayDeductions(loadNumbers) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http
      .post(this.getcarrierinvoiceurl + "/deduction", loadNumbers, options)
      .pipe(
        map((response) => response.json()),
        catchError((error: Response) => {
          return observableThrowError(error);
        })
      );
  }

}
